import { jsx as _jsx } from "react/jsx-runtime";

function SvgFilter() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 4a1 1 0 112 0 1 1 0 01-2 0zM6.17 3H3a1 1 0 000 2h3.17a3.001 3.001 0 005.66 0H21a1 1 0 100-2h-9.17a3.001 3.001 0 00-5.66 0zM15 9c1.306 0 2.418.835 2.83 2H21a1 1 0 110 2h-3.17a3.001 3.001 0 01-5.66 0H3a1 1 0 110-2h9.17A3.001 3.001 0 0115 9zm0 2a1 1 0 110 2 1 1 0 010-2zM2 20a1 1 0 011-1h3.17a3.001 3.001 0 015.66 0H21a1 1 0 110 2h-9.17a3.001 3.001 0 01-5.66 0H3a1 1 0 01-1-1zm8 0a1 1 0 10-2 0 1 1 0 002 0z"
    }, void 0)
  }), void 0);
}

export default SvgFilter;